export interface NumberOfPrints {
  value?: number;
  label: string;
}

export const numberOfPrintsLists = [
  { value: undefined, label: "選択してください" },
  { value: 30, label: "30枚" },
  { value: 50, label: "50枚" },
  { value: 100, label: "100枚" },
  { value: 200, label: "200枚" },
  { value: 300, label: "300枚" },
  { value: 400, label: "400枚" },
  { value: 500, label: "500枚" }
] as NumberOfPrints[];
